import { createApp } from '@app/adapters/create-app'

import Carousel from '@app/application/reconciliation/components/status-carousel.vue'

export default (): void => {
  window.onDomLoad(($dom) => {
    const doc = $dom[0]

    const container = doc.querySelector(
      '[data-behaviour="reconciliation-carousel"]'
    ) as HTMLElement

    if (container) {
      createApp(Carousel, {
        ledgerId: parseInt(container.dataset.ledgerId || '0', 10),
        previousAction: container.dataset.previousAction,
        nextAction: container.dataset.nextAction,
        statuses: JSON.parse(container.dataset.statuses || '[]'),
        workflowId: parseInt(container.dataset.workflowId || '0', 10),
      }).mount(container)
    }
  })
}
